import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragsArtKlasseListStatus: 'idle',
    loadAuftragsArtKlasseListError: undefined as any,
    loadAuftragsArtKlasseListLastArgs: undefined as any,
    loadAuftragsArtKlasseStatus: 'idle',
    loadAuftragsArtKlasseError: undefined as any,
    saveAuftragsArtKlasseStatus: 'idle',
    saveAuftragsArtKlasseError: undefined as any,
    deleteAuftragsArtKlasseStatus: 'idle',
    deleteAuftragsArtKlasseError: undefined as any,

    auftragsArtKlasseList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragsArtKlasseList = createAsyncThunk('auftragsArtKlasseSlice/loadAuftragsArtKlasseList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragsArtKlasseSlice.loadAuftragsArtKlasseListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftartklasse/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsArtKlasseListStatus } = getState().auftragsArtKlasseSlice
        return loadAuftragsArtKlasseListStatus !== 'pending'
    }
})

export const loadAuftragsArtKlasse = createAsyncThunk('auftragsArtKlasseSlice/loadAuftragsArtKlasse', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftartklasse/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsArtKlasseStatus } = getState().auftragsArtKlasseSlice
        return loadAuftragsArtKlasseStatus !== 'pending'
    }
})

export const saveAuftragsArtKlasse = createAsyncThunk('auftragsArtKlasseSlice/saveAuftragsArtKlasse', async ({ auftragsArtKlasse }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragsArtKlasse?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftartklasse/${ auftragsArtKlasse?.HDR_ID }/`,
            prepareData(auftragsArtKlasse),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftartklasse/`,
            prepareData(auftragsArtKlasse),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragsArtKlasseStatus } = getState().auftragsArtKlasseSlice
        return saveAuftragsArtKlasseStatus !== 'pending'
    }
})

export const deleteAuftragsArtKlasse = createAsyncThunk('auftragsArtKlasseSlice/deleteAuftragsArtKlasse', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisauftartklasse/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragsArtKlasseStatus } = getState().auftragsArtKlasseSlice
        return deleteAuftragsArtKlasseStatus !== 'pending'
    }
})

const AuftragsArtKlasseSlice = createSlice({
    name: 'auftragsArtKlasseSlice',
    initialState,
    reducers: {
        resetloadAuftragsArtKlasseListError: (state) => {
            state.loadAuftragsArtKlasseListError = undefined
        },
        resetloadAuftragsArtKlasse: (state) => {
            state.formItem = undefined
            state.loadAuftragsArtKlasseError = undefined
        },
        resetloadAuftragsArtKlasseError: (state) => {
            state.loadAuftragsArtKlasseError = undefined
        },
        resetsaveAuftragsArtKlasse: (state) => {
            state.formItem = undefined
            state.saveAuftragsArtKlasseError = undefined
        },
        resetsaveAuftragsArtKlasseError: (state) => {
            state.saveAuftragsArtKlasseError = undefined
        },
        resetdeleteAuftragsArtKlasseError: (state) => {
            state.deleteAuftragsArtKlasseError = undefined
        },
        removeFromAuftragsArtKlasseListById: (state, action) => {
            state.auftragsArtKlasseList = state.auftragsArtKlasseList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragsArtKlasseListByIds: (state, action) => {
            state.auftragsArtKlasseList = state.auftragsArtKlasseList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragsArtKlasseList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragsArtKlasseListStatus = 'preloaded'
            state.loadAuftragsArtKlasseListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragsArtKlasseList = []
            state.loadAuftragsArtKlasseListStatus = 'idle'
            state.loadAuftragsArtKlasseListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragsArtKlasseList.pending, (state) => {
            state.loadAuftragsArtKlasseListStatus = 'pending'
            state.loadAuftragsArtKlasseListError = undefined
        })
        builder.addCase(loadAuftragsArtKlasseList.fulfilled, (state, action) => {
            state.loadAuftragsArtKlasseListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragsArtKlasseListLastArgs = action.payload.args

            {
                state.auftragsArtKlasseList = action.payload.data

            }
        })
        builder.addCase(loadAuftragsArtKlasseList.rejected, (state, action) => {
            state.loadAuftragsArtKlasseListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsArtKlasseListError = action.error.message
            } else {
                state.loadAuftragsArtKlasseListError = action.payload
            }
        })

        builder.addCase(loadAuftragsArtKlasse.pending, (state) => {
            state.loadAuftragsArtKlasseStatus = 'pending'
            state.loadAuftragsArtKlasseError = undefined
        })
        builder.addCase(loadAuftragsArtKlasse.fulfilled, (state, action) => {
            state.loadAuftragsArtKlasseStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsArtKlasseList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsArtKlasseList.push(newItem) }
                else { state.auftragsArtKlasseList[i] = { ...state.auftragsArtKlasseList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragsArtKlasse.rejected, (state, action) => {
            state.loadAuftragsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsArtKlasseError = action.error.message
            } else {
                state.loadAuftragsArtKlasseError = action.payload
            }
        })

        builder.addCase(saveAuftragsArtKlasse.pending, (state) => {
            state.saveAuftragsArtKlasseStatus = 'pending'
            state.saveAuftragsArtKlasseError = undefined
        })
        builder.addCase(saveAuftragsArtKlasse.fulfilled, (state, action) => {
            state.saveAuftragsArtKlasseStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsArtKlasseList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsArtKlasseList.push(newItem) }
                else { state.auftragsArtKlasseList[i] = { ...state.auftragsArtKlasseList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragsArtKlasse.rejected, (state, action) => {
            state.saveAuftragsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragsArtKlasseError = action.error.message
            } else {
                state.saveAuftragsArtKlasseError = action.payload
            }
        })

        builder.addCase(deleteAuftragsArtKlasse.pending, (state) => {
            state.deleteAuftragsArtKlasseStatus = 'pending'
            state.deleteAuftragsArtKlasseError = undefined
        })
        builder.addCase(deleteAuftragsArtKlasse.fulfilled, (state, action) => {
            state.deleteAuftragsArtKlasseStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragsArtKlasseList = state.auftragsArtKlasseList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragsArtKlasseList = state.auftragsArtKlasseList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragsArtKlasse.rejected, (state, action) => {
            state.deleteAuftragsArtKlasseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragsArtKlasseError = action.error.message
            } else {
                state.deleteAuftragsArtKlasseError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragsArtKlasseListError,
    resetloadAuftragsArtKlasse,
    resetloadAuftragsArtKlasseError,
    resetsaveAuftragsArtKlasse,
    resetsaveAuftragsArtKlasseError,
    resetdeleteAuftragsArtKlasseError,
    removeFromAuftragsArtKlasseListById,
    removeFromAuftragsArtKlasseListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragsArtKlasseSlice.actions
export default AuftragsArtKlasseSlice.reducer
